<!-- ROOM DETAIL -->
<ng-template #oldRoomDetail let-md>
  @for (resource of modalData.resources; track $index) {
    <div class="room-wrapper">
      <div class="col col-12 col-md-6">
        <div class="row">
          <div class="col-md-12">
            <table class="popup-table">
              <tr>
                <th>{{ translation.resource.name | transloco }}</th>
                <td>
                  {{
                    (resource.displayNameForApp | localizedString) ??
                      (resource.displayName | localizedString) ??
                      (resource.name | localizedString)
                  }}
                </td>
              </tr>
              @if (
                resource.displayNameForApp != null &&
                (resource.displayNameForApp | localizedString) !== (resource.name | localizedString)
              ) {
                <tr>
                  <th>{{ translation.resource.alternativeName | transloco }}</th>
                  <td>{{ resource.name }}</td>
                </tr>
              }
              <tr>
                <th>{{ translation.leftMenu.type | transloco }}</th>
                <td>
                  {{ configService.getResourceTypeFromId(resource.resourceTypeId).name | localizedString }}
                </td>
              </tr>
              @if (configService.getResourceTypeFromId(resource.resourceTypeId).capacityVisible) {
                <tr>
                  <th>
                    {{ translation.resourceDetail.capacity | transloco }}
                  </th>
                  <td>
                    {{ resource.capacity !== null ? resource.capacity : (translation.common.unlimited | transloco) }}
                  </td>
                </tr>
              }
              @for (
                simpleFilter of configService.getSimpleFiltersByResourceTypeId(resource, translocoService);
                track simpleFilter
              ) {
                @if (simpleFilter.value !== undefined && simpleFilter.value !== null && simpleFilter.value !== '') {
                  <tr>
                    <th>{{ simpleFilter.name | localizedString }}</th>
                    <td>
                      @if (simpleFilter.value === true) {
                        <cue-icon [icon]="ICONS.cueCheck" class="bool-icon correct" />
                      }

                      @if (simpleFilter.value === false) {
                        <cue-icon [icon]="ICONS.cueClose" class="bool-icon incorrect" />
                      }

                      @if (simpleFilter.value !== true && simpleFilter.value !== false) {
                        <div [innerHTML]="simpleFilter.value | localizedString | cueCustomUnsafeSanitize"></div>
                      }
                    </td>
                  </tr>
                }
              }
            </table>
            @for (
              enumerableFilter of configService.getEnumerableFiltersByResourceTypeId(resource);
              track enumerableFilter
            ) {
              <ul class="room-properties">
                <div class="item-label">
                  {{ enumerableFilter.name | localizedString }}
                </div>
                @for (value of enumerableFilter.value; track value) {
                  <li>
                    <div class="img-wrapper">
                      <img
                        [ngStyle]="{
                          'object-position': value.imageObjectPosition,
                        }"
                        [class.!object-cover]="value.imagePreferCover"
                        [src]="value.imageUrl | imageWidth: 90"
                      />
                    </div>
                    <span class="descriptionText">
                      {{ value.title | localizedString }}
                    </span>
                  </li>
                }
              </ul>
            }
            <cue-working-hours [workingHourInfo]="resource" />
          </div>
        </div>

        <cue-open-in-navigation-button
          [resourceId]="resource.idForFiltering"
          [enabled]="configService.value.navigationAppEnabled"
          [navigationAppUrl]="configService.value.navigationAppUrl"
        />
      </div>
      <div class="col col-12 col-md-6">
        <div class="row mb-3">
          <div class="col-md-12" style="text-align: center">
            <cue-file-gallery [files]="resource.files" />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            @if (resource.breadcrumb) {
              <div class="breadcrumb-container">
                @for (item of resource.breadcrumb; track item; let i = $index) {
                  <span class="breadcrumb">
                    @if (i !== 0) {
                      <cue-icon [icon]="ICONS.cueArrowRight" />
                    }
                    <span class="part">{{ item.name | localizedString }}</span>
                  </span>
                }
              </div>
            }
            @if ((resourceService.getNewMapUrlForResource(resource) | async).data; as newMapFile) {
              <assist-new-resource-map
                [areaId]="resource.mapInfos[0]?.areaId!"
                [imageSrc]="newMapFile"
                [resourceId]="resource.idForFiltering"
              />
            }
          </div>
        </div>
      </div>
    </div>
  }
</ng-template>

<ng-template #newRoomDetail>
  <assist-reservation-detail-resource-tab
    [eventStart]="modalData.existingOrder.date"
    [resourceAttendees]="vm().reservation.resourceAttendees"
  />
</ng-template>

<!-- EXISTING ORDER DETAIL -->
<ng-template #existingNewOrderDetail>
  <assist-reservation-detail-orders-tab
    [eventDate]="modalData.existingOrder.date"
    mode="detail"
    state="view"
    [reservation]="vm().reservation"
    [currentOrders]="[]"
  />
</ng-template>

<ng-template #existingOldOrderDetail>
  <div class="order-wrapper">
    {{ (modalData.existingOrder?.iCalUid ? translation.orders.eventStart : translation.orders.created) | transloco }}
    {{ modalData.existingOrder.date | dateFormat }}
    {{ modalData.existingOrder.date | timeFormat }}

    @for (order of modalData.existingOrder.orders; track order) {
      <kendo-expansionpanel class="show-panel" [expanded]="modalData.existingOrder.orders.length == 1">
        <ng-template kendoExpansionPanelTitleDirective>
          <div class="expansionpanel-title space-between">
            {{ order.requestCode }}
            <div class="end-part count">
              <span>
                {{ order.created | dateFormat }}
                {{ order.created | timeFormat }}
              </span>
            </div>
          </div>
        </ng-template>
        <div>
          @if (order.note) {
            <div class="description">
              <p>
                {{ order.note }}
              </p>
            </div>
          }

          @for (item of order.items; track item) {
            <div class="order-item">
              <div class="image-wrapper">
                <img
                  [ngStyle]="{
                    'object-position': getServiceInfo(item).imageObjectPosition,
                  }"
                  [class.!object-cover]="getServiceInfo(item).imagePreferCover"
                  [src]="getServiceInfo(item).imageUrl ?? 'assets/images/placeholder-order.svg' | imageWidth: 100"
                />
              </div>
              <div class="text-wrapper">
                <div class="item-heading">
                  <p>
                    {{ getServiceInfo(item).name | localizedString }}
                  </p>
                </div>
                <div class="item-inner-count">
                  @if (item.note) {
                    <span class="item-description">
                      {{ item.note }}
                    </span>
                  }
                  @if (!item.note) {
                    <span class="item-description no-description">
                      {{ translation.orders.noDescription | transloco }}
                    </span>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      </kendo-expansionpanel>
    }
  </div>
</ng-template>

<!-- ORDER DETAIL -->
<ng-template #orderDetail [formGroup]="form">
  <div class="order-wrapper new-order">
    @if ($any(form.get('items')).length == 0) {
      <h4>{{ translation.orders.newServiceTitle | transloco }}</h4>
      <p>{{ translation.orders.newServiceInstruction | transloco }}</p>
    }
    @for (order of orders.controls; track order; let index = $index) {
      <ng-container [formGroup]="$any(order)">
        <div class="order-item">
          <div class="image-wrapper">
            <img
              [src]="
                (order.value.imageUrl === null || order.value.imageUrl === ''
                  ? 'assets/images/placeholder-order.svg'
                  : order.value.imageUrl
                ) | imageWidth: 100
              "
              class="service-image"
            />
          </div>
          <div class="text-wrapper">
            <div class="item-heading">
              <p>
                {{ order.value.name }}
              </p>
            </div>
            <div class="item-inner-count">
              @if (order.value.noteAllowed) {
                <textarea cueRtl [class.error]="order.get('note').invalid" formControlName="note"></textarea>
                @if (order.get('note').invalid) {
                  <p class="error">
                    {{ translation.orders.minimalLength | transloco: { length: order.get('noteMinLength').value } }}
                  </p>
                }
              }
            </div>
          </div>
          <div (click)="remove(index)" class="delete-button">
            <cue-icon [icon]="ICONS.cueClose" />
          </div>
        </div>
      </ng-container>
    }

    <div class="order-select">
      @if (adding) {
        <assist-service-select
          [type]="modalData.existingOrder?.iCalUid ? 'event' : 'resource'"
          (cancelled)="onCancel()"
          (itemSelected)="onSelect($event)"
          [resourceGuid]="modalData.resources[0].guid"
        />
      }
    </div>

    <br />

    @if (!adding) {
      <div (click)="add()" class="add-item-button">
        <cue-icon [icon]="ICONS.cueAdd" />
        {{ translation.orders.addItem | transloco }}
      </div>
    }

    @if (orders.length > 0) {
      <div class="order-note">
        <h4>{{ translation.orders.note | transloco }}</h4>
        <textarea cueRtl formControlName="note"> </textarea>
      </div>
    }
  </div>
</ng-template>

<!-- RESERVATION DETAIL -->
<ng-template #reservationDetail>
  @if (vm().loading) {
    <cue-loading />
  }
  @if (!vm().reservation && !vm().loading) {
    <div>
      {{ translation.common.notFoundReservation | transloco }}
    </div>
  }
  @if (vm().reservation && !vm().loading) {
    <div class="reservation-content">
      <div class="row">
        <div class="col-md-12">
          <cue-datetime-info
            [dateTime]="vm().reservation.start!.utcDateTime"
            [type]="'from'"
            [isStart]="true"
            class="startEnd"
          />
          <cue-datetime-info
            [dateTime]="vm().reservation.end!.utcDateTime"
            [type]="'to'"
            [isStart]="false"
            class="startEnd"
          />

          <div class="line" style="margin: 16px 0"></div>
        </div>
      </div>
      <div class="reservation-scrollable">
        <div class="reservation-content-inner">
          <div class="row">
            <div class="col-md-12">
              <p class="item-label">
                {{ translation.reservationPopup.location | transloco }}
              </p>
              @for (rA of vm().reservation!.resourceAttendees; track $index) {
                <div class="flex flex-row gap-2 justify-between mb-2">
                  <div class="flex flex-row gap-2">
                    <div>{{ rA.resource | resourceTitle }}</div>
                    @if (configService.value.navigationEnabled && rA.resource!) {
                      <div class="navigate-button" (click)="onNavigate(rA.resource)">
                        <p>
                          <cue-icon [icon]="ICONS.cueDirections" />
                          {{ translation.reservations.navigateTo | transloco }}
                        </p>
                      </div>
                    }
                  </div>
                  <div class="state" [ngClass]="getTextKeyAndClass(rA)[1]">
                    <p>{{ getTextKeyAndClass(rA)[0] | transloco }}</p>
                  </div>
                </div>
              }

              <div class="line"></div>
            </div>
          </div>
          @if (configService.isTouchoneCalendar()) {
            <div class="row">
              <div class="col-md-12">
                <p class="item-label">
                  {{ translation.reservationPopup.visibility.title | transloco }}
                </p>
                <div class="flex-inline">
                  <div class="descriptionText">
                    {{
                      (vm().reservation.visibility === 'private'
                        ? translation.reservationPopup.visibility.private
                        : translation.reservationPopup.visibility.public
                      ) | transloco
                    }}
                  </div>
                </div>
              </div>
            </div>
          }
          <div class="row reservation-name">
            <div class="col-md-12">
              <div class="name-cont">
                @if (vm().reservation.showConfirmButton) {
                  <p class="warning-label">
                    {{
                      translation.reservations.confirmationRequiredUntil
                        | transloco
                          : { until: vm().reservation.resourceAttendees[0].confirmationMetadata.higherBorderTime }
                    }}
                  </p>
                }
                <p class="item-label">
                  {{ translation.reservationPopup.name | transloco }}
                </p>
                <div class="value">
                  {{ vm().reservation.subject | subjectPipe }}
                </div>
              </div>
              <div class="line"></div>
            </div>
          </div>
          @if (!vm().reservation.isOrganizer && vm().reservation.organizer) {
            <div class="row">
              <div class="col-12">
                <p class="item-label">
                  {{ translation.reservationPopup.organizer | transloco }}
                </p>
                <div></div>
                <span
                  >{{ vm().reservation.organizer.emailAddress?.name }} ({{
                    vm().reservation.organizer.emailAddress?.address
                  }}
                  )</span
                >
              </div>
            </div>
          }
          @if (licensingService.isPremiumResourceLike(vm().reservation.resourceAttendees[0].resource)) {
            <div class="row">
              @if (vm().reservation.requiredAttendees.length > 0) {
                <div class="col-12">
                  <p class="item-label">
                    {{ translation.reservationPopup.requiredAttendees | transloco }}
                  </p>
                  <div class="attendees-cont">
                    @for (attendee of vm().reservation.requiredAttendees; track attendee) {
                      <div class="attendee-card">
                        <div class="attendee-ico" [ngStyle]="{ 'background-color': attendee.color }">
                          <span class="initials">
                            {{ attendee.initials }}
                          </span>
                        </div>
                        <div class="attendee-text">{{ attendee.name }} ({{ attendee.email }})</div>
                      </div>
                    }
                  </div>
                </div>
              }
              @if (vm().reservation.optionalAttendees.length > 0) {
                <div class="col-12">
                  <p class="item-label">
                    {{ translation.reservationPopup.optionalAttendees | transloco }}
                  </p>
                  <div class="attendees-cont">
                    @for (attendee of vm().reservation.optionalAttendees; track attendee) {
                      <div class="attendee-card">
                        <div class="attendee-ico" [ngStyle]="{ 'background-color': attendee.color }">
                          <span class="initials">
                            {{ attendee.initials }}
                          </span>
                        </div>
                        <div class="attendee-text">{{ attendee.name }} ({{ attendee.email }})</div>
                      </div>
                    }
                  </div>
                  <div class="line"></div>
                </div>
              }
            </div>
          }
          <div class="row">
            <div class="col-md-12">
              <div class="description-cont">
                <p class="item-label">
                  {{ translation.reservationPopup.description | transloco }}
                </p>
                <div [innerHTML]="vm().reservation.bodyHtml" class="descriptionText"></div>
              </div>
              <div class="line"></div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <p class="item-label">
                {{ translation.reservationPopup.eventShow | transloco }}
              </p>
              <div class="flex-inline">
                <div class="kendo-switch-wrapper">
                  {{ vm().reservation.showAs.key | transloco }}
                </div>
              </div>

              <div class="line"></div>
            </div>
          </div>
          @if (
            licensingService.isPremiumResourceLike(vm().reservation.resourceAttendees[0].resource) &&
            !configService.isEWS()
          ) {
            @if (configService.isGspace() || vm().reservation.onlineMeetingProvider) {
              <div class="row">
                <div class="col-md-12">
                  <p class="item-label">
                    {{ translation.reservationPopup.onlineMeeting | transloco }}
                  </p>
                  {{
                    vm().reservation.onlineMeetingProvider ? (configService.isGspace() ? '' : 'Microsoft Teams') : ''
                  }}
                  @if (configService.isGspace() && vm().reservation.onlineMeetingProvider) {
                    <a [href]="vm().reservation.onlineMeetingProvider" target="_blank" rel="noreferrer noopener"
                      >Hangouts Meet</a
                    >
                  }
                  <div class="line"></div>
                </div>
              </div>
            }
          }
        </div>
      </div>
    </div>
  }
</ng-template>

<cue-modal [modal]="modal">
  <cue-modal-header
    (headerClose)="modal.close()"
    (tabClick)="changeTab($event)"
    [tabsVisible]="true"
    [tabs]="tabs()"
    class="desktop-tabs"
    [title]="title()"
  />
  <cue-modal-body>
    <div class="modal-body" style="height: unset">
      @if (state !== 'loading') {
        <!--        ORDER DETAIL-->
        @if (!modalData.existingOrder && activeTab === 0) {
          <ng-container [ngTemplateOutlet]="orderDetail" />
        }

        @if (modalData.existingOrder && activeTab === 0) {
          <ng-container [ngTemplateOutlet]="vm().reservation ? existingNewOrderDetail : existingOldOrderDetail" />
        }
        <!--     RESERVATIOMN DETAIL -->
        @if (modalData.existingOrder?.iCalUid && activeTab === 1) {
          <ng-container [ngTemplateOutlet]="reservationDetail" />
        }
        <!--        ROOM DETAIL-->
        @if (modalData.existingOrder?.iCalUid ? activeTab === 2 : activeTab === 1) {
          <ng-container [ngTemplateOutlet]="vm().reservation ? newRoomDetail : oldRoomDetail" />
        }
      }

      @if (state === 'loading') {
        <cue-loading />
      }
    </div>
  </cue-modal-body>

  @if (state !== 'loading') {
    <cue-modal-footer>
      <cue-button (click)="modal.close(false)" [icon]="ICONS.cueClose" [smallResponsive]="true">
        {{ translation.reservationPopup.close | transloco }}
      </cue-button>
      @if (!modalData.existingOrder) {
        <cue-button
          (click)="order()"
          [disabled]="orders.length === 0"
          [icon]="ICONS.cueOrders"
          [smallResponsive]="true"
          [type]="'service'"
        >
          {{ translation.orders.newRequest | transloco }}
        </cue-button>
      }
    </cue-modal-footer>
  }
</cue-modal>
